var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2997 3.832C14.1397 2.818 14.7037 1.405 14.5497 0C13.3417 0.049 11.8797 0.805 11.0147 1.819C10.2377 2.717 9.55772 4.154 9.74172 5.531C11.0877 5.636 12.4637 4.847 13.3017 3.832H13.2997ZM16.3217 12.75C16.3557 16.382 19.5077 17.591 19.5417 17.607C19.5167 17.692 19.0397 19.329 17.8817 21.02C16.8817 22.482 15.8437 23.939 14.2077 23.969C12.6007 23.998 12.0847 23.016 10.2467 23.016C8.41072 23.016 7.83672 23.939 6.31472 23.998C4.73672 24.058 3.53472 22.417 2.52472 20.961C0.464716 17.981 -1.11028 12.541 1.00472 8.869C2.05372 7.045 3.93172 5.89 5.96972 5.861C7.51972 5.831 8.98272 6.904 9.92972 6.904C10.8777 6.904 12.6557 5.614 14.5247 5.803C15.3077 5.836 17.5037 6.119 18.9147 8.184C18.8007 8.254 16.2937 9.714 16.3207 12.75",
    fill: "#04162D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/AppleIcon.8f238fd57856c2409a697d020669d130.svg";
export { ForwardRef as ReactComponent };